export default __webpack_public_path__ + "static/media/zachphoto.da067088.jpg";